<template>
    <div class="curso-list d-flex">


        <div class="row" >
            <div :class="'curso-list-item col-12 col-md-'+columnas"
                v-for="curso in cursos"
                :key="curso.categoria.id">
                <curso-card
                    :show_curso="show_curso"
                    :curso="curso.categoria"
                    @click="emitCursoClick(curso.categoria,curso.producto)" />

            </div>
        </div>

  </div>
</template>

<script>
import CursoCard from "./CursoCard";


export default {
	props: ["cursos","columnas","carouselactive","show_curso"],
	components: {
        CursoCard,
    },
	methods: {
		emitCursoClick(categoria,producto) {
            this.$emit("cursoClick", categoria,producto);

        }

	},
};
</script>



